import {QuestLanding} from './ui/QuestLanding'
import {QuestView} from './ui/QuestView'
import {ShareView} from './ui/ShareView'
import {XrCheck} from './ui/XrCheck'

// Routes (plan §2 / §8.1):
//   /a/:alternativeId            — geo quest (M1): GPS+compass aligned AR
//   /c/:alternativeId/:anchorId  — single-checkpoint share preview (M2.5)
//   /xr-check                    — WebXR capability probe (Android bring-up)
// Query flags: ?mode=viewer (orbit viewer), ?mode=list (checkpoint list),
// ?debug=1 (alignment overlay), ?fakegps=lat,lng[,acc], ?fakeheading=deg,
// ?engine=webxr|xr8 (force an AR engine — for A/B testing on one device).
export function App() {
  const path = window.location.pathname
  const params = new URLSearchParams(window.location.search)
  const forceViewer = params.get('mode') === 'viewer'

  if (path === '/xr-check' || path === '/xr-check/') return <XrCheck />

  const share = path.match(/^\/c\/(\d+)\/(\d+)\/?$/)
  if (share) {
    return <ShareView alternativeId={share[1]} anchorId={share[2]} forceViewer={forceViewer} />
  }

  const quest = path.match(/^\/a\/(\d+)\/?$/)
  if (quest) {
    return params.get('mode') === 'list' ? (
      <QuestLanding alternativeId={quest[1]} />
    ) : (
      <QuestView alternativeId={quest[1]} />
    )
  }

  return (
    <div className="center-note">
      <h1>The Alternatives — AR</h1>
      <p className="dim">
        Open a link like <code>/a/&lt;alternative-id&gt;</code> or{' '}
        <code>/c/&lt;alternative-id&gt;/&lt;checkpoint-id&gt;</code>.
      </p>
    </div>
  )
}
